import { triggerTracking } from '@zoopla/tracking';

export const trackNudgeOpen = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'user_prompt',
        eventAction: 'modal_shown',
        eventLabel: 'pdp_track_prompt'
    });
};

export const trackNudgeClose = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'user_prompt',
        eventAction: 'modal_closed',
        eventLabel: 'pdp_track_prompt'
    });
    sessionStorage.setItem('pdp_nudge_modal', 'true');
};

export const trackNudgeClick = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'user_prompt',
        eventAction: 'click_to_track',
        eventLabel: 'pdp_track_prompt'
    });
};
